import DateMaster from './date_master';

export default class TackMapper {
  static map(tackData) {
    return {
      slug: tackData.slug,
      wordText: tackData.word_text,
      partOfSpeech: tackData.part_of_speech,
      createdAt: DateMaster.parseUTC(tackData.created_at),
      nextInterval: tackData.next_interval,
      currentInterval: tackData.current_interval,
      day: tackData.day,
      nextSendDate: DateMaster.parseUTC(tackData.next_send_date),
      lastSentDate: DateMaster.parseUTC(tackData.last_sent_date),
      done: tackData.done,
      language: tackData.language,
      likedBy: tackData.liked_by,
      recommendedWords: tackData.recommended_words
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/utils/tack_mapper.js